import React from "react";
import { FaFacebookF, FaLinkedinIn } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <>
      <footer className="footer-section">
        <div className="container">
          <div className="footer-cta pt-5 pb-5">
            <div className="row">
              <div className="col-xl-4 col-md-4 mb-30">
                <div className="single-cta">
                  <i className="fas fa-map-marker-alt" />
                  <div className="cta-text">
                    <h4>Find us</h4>
                    <span>Shree Vinayak Motors ,Durgapura,Jaipur</span>
                  </div>
                </div>
              </div>
              <div className="col-xl-4 col-md-4 mb-30">
                <div className="single-cta">
                  <i className="fas fa-phone" />
                  <div className="cta-text">
                    <h4>Call us</h4>
                    <span>
                      <a
                        href="tel:+916367607678"
                        style={{ color: "#757575", textDecoration: "none" }}
                      >
                        +916367607678
                      </a>
                    </span>
                  </div>
                </div>
              </div>
              <div className="col-xl-4 col-md-4 mb-30">
                <div className="single-cta">
                  <i className="far fa-envelope-open" />
                  <div className="cta-text">
                    <h4>Mail us</h4>
                    <span>
                      <a
                        href="mailto:info@vinayak24x7.com"
                        style={{ color: "#757575", textDecoration: "none" }}
                      >
                        info@vinayak24x7.com
                      </a>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="footer-content pt-5 pb-5">
            {/* <div className="row">
              <div className="col-lg-12 col-md-12">
                <div className="mybutton">
                  <a
                    rel="nofollow"
                    href="https://api.whatsapp.com/send?phone=916367607678&text=My car has broken down, please send help 🙏"
                    className="whatsapp btn2 btn"
                  >
                    <i
                      className="fab fa-whatsapp"
                      aria-hidden="true"
                      style={{ fontSize: 30, fontWeight: 500 }}
                    />{" "}
                    &nbsp;Get Instant Mechanic
                  </a>
                </div>
              </div>
            </div> */}
            <div className="row">
              <div className="col-xl-4 col-lg-4 mb-50">
                <div className="footer-widget">
                  <div className="footer-logo">
                    <a href="index.html">
                      <img src="/logo.png" className="img-fluid" alt="logo" />
                    </a>
                  </div>
                  <div className="footer-text">
                    <p>
                      Road Mechance24x7 offers 24/7 road assistance, emergency
                      repairs, and reliable vehicle maintenance. Trust expert
                      mechanics for on-site solutions, ensuring safety and
                      hassle-free journeys. Available anytime,&nbsp;anywhere!.
                    </p>
                  </div>
                  <div className="footer-social-icon">
                    <span>Follow us</span>

                    <a
                      href="https://www.facebook.com/vinayak24x7"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Facebook"
                      className="social-icon facebook"
                    >
                      <FaFacebookF />
                    </a>

                    <a
                      href="https://twitter.com"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Twitter"
                      className="social-icon twitter"
                    >
                      <FaXTwitter />
                    </a>

                    <a
                      href="https://www.linkedin.com"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="LinkedIn"
                      className="social-icon linkedin"
                    >
                      <FaLinkedinIn />
                    </a>
                  </div>
                </div>
              </div>

              <div className="col-xl-4 col-lg-4 col-md-6 mb-50">
                <div className="footer-widget">
                  <div className="footer-widget-heading">
                    <h3>Rating &amp; Certification</h3>
                  </div>
                  <div className="footer-text mb-25">
                    <p>Don’t miss to subscribe to our new feeds, </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="copyright-area">
            <div className="container">
              <div className="row">
                <div className="col-xl-12 col-lg-12 text-center text-lg-left">
                  <div className="copyright-text">
                    <p>Copyright © 2026 Shree Vinayak Motors</p>
                  </div>
                </div>
                <div className="col-xl-6 col-lg-6 d-lg-block text-right">
                  <div className="footer-menu">
                    <ul>
                      <li>
                        <Link to="/">Home</Link>
                      </li>
                      <li>
                        <Link to="/terms-conditions">Terms</Link>
                      </li>
                      <li>
                        <Link to="/privacy-policy">Privacy&Policy</Link>
                      </li>
                      <li>
                        <Link to="/contact-us">Contact</Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
